export default __webpack_public_path__ + "static/media/attendance-grey.9b3ab73a.svg";